module.exports = __webpack_public_path__ + "img/bruce-mars.c0421fd9.jpg";